S.landing =
  {
      elements: {
          $arrow: null,
          $text: null,
      },
      init()
      {
          this.elements.$arrow.click(() =>
          {
              this.scrollToText();
          });
      },
      scrollToText()
      {
          $(document).scrollTop(this.elements.$text.offset().top);
      },
  }
;
